<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0;">
            <div class="header-icon-wrap mr-3">
              <i class="fe fe-home" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Claims Awaiting Approval</h4>
              <small style="opacity: 0.8;">Facilities whose verified claims were forwarded to the ES for approval for payment</small>
            </div>
          </div>
        </div>
      </div>

      <section style="margin-top: -20px;">
        <div class="container pb-5">
          <div class="card shadow-sm table-card">
            <div class="d-flex flex-wrap align-items-center px-4 pt-4 pb-3" style="gap: 8px;">
              <i class="fe fe-activity text-primary mr-1"></i>
              <h6 class="mb-0 font-weight-bold">Facilities awaiting approval</h6>
              <span class="badge badge-soft-info">{{ providers.length }}</span>
              <small class="text-muted ml-2" v-if="providers.length">{{ totalClaims.toLocaleString() }} claims · ₦{{ fmt(totalAmount) }} · oldest first</small>
              <button v-if="providers.length" class="btn btn-sm btn-submit ml-auto" @click="open(providers[0])">
                <i class="fe fe-play mr-1"></i> Start approving
              </button>
            </div>
            <div class="table-responsive">
              <table class="table align-td-middle mb-0">
                <thead style="background: #f8fafc;">
                  <tr>
                    <th class="table-th">#</th>
                    <th class="table-th">Facility Name</th>
                    <th class="table-th">Contact</th>
                    <th class="table-th text-center">Claims</th>
                    <th class="table-th text-right">Amount to approve</th>
                    <th class="table-th">Waiting since</th>
                    <th class="table-th"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(provider, index) in providers" :key="provider.id" class="table-row">
                    <td class="px-4 py-3 text-muted small">{{ index + 1 }}</td>
                    <td class="py-3">
                      <span class="font-weight-bold">{{ provider.agency_name }}</span>
                      <button class="btn btn-sm ml-2" style="padding: 2px 6px;" @click="copyText(provider)" title="Copy name">
                        <i class="fe fe-copy text-muted"></i>
                      </button>
                    </td>
                    <td class="py-3 small">{{ provider.email }}<div class="text-muted">{{ provider.phone_number }}</div></td>
                    <td class="py-3 text-center">
                      <span class="badge badge-soft-primary">{{ provider.claims_count || 0 }}</span>
                    </td>
                    <td class="py-3 text-right font-weight-bold">₦{{ fmt(provider.approved_total) }}</td>
                    <td class="py-3 small text-muted">{{ provider.oldest | moment("D MMM YYYY") }}</td>
                    <td class="py-3 pr-4 text-right">
                      <button type="button" class="btn btn-sm btn-submit" @click="open(provider)">
                        <i class="fe fe-eye mr-1"></i> View Claims
                      </button>
                    </td>
                  </tr>
                  <tr v-if="!isLoading && !providers.length">
                    <td colspan="7" class="text-center py-5 text-muted">
                      <i class="fe fe-inbox" style="font-size: 2rem; opacity: 0.3;"></i>
                      <p class="mt-2 mb-0">No claims are waiting for approval</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="vld-parent">
          <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

/**
 * Facilities with claims awaiting the ES for approval for payment, oldest waiting first (GET claims/awaiting-es).
 * Opening one passes the whole list as ?queue=, so the claims page can move on to the next facility after approving.
 */
export default {
  components: { Navbar, Loading },
  data() {
    return { user: null, providers: [], totalClaims: 0, totalAmount: 0, isLoading: false, fullPage: true };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.getProviders();
  },
  methods: {
    fmt(v) { return Number(v || 0).toLocaleString(undefined, { maximumFractionDigits: 0 }); },
    copyText(provider) {
      navigator.clipboard.writeText(provider.agency_name);
      this.$toasted.info("Copied to clipboard", { position: "top-center", duration: 3000 });
    },
    getProviders() {
      this.isLoading = true;
      this.axios.get("/api/v1/auth/claims/awaiting-es")
        .then((response) => {
          this.providers = response.data.data || [];
          this.totalClaims = response.data.total_claims || 0;
          this.totalAmount = response.data.total_amount || 0;
        })
        .catch((error) => { console.error(error); })
        .finally(() => { this.isLoading = false; });
    },
    open(provider) {
      this.$router.push({ path: `/all-claims/${provider.id}`, query: { queue: this.providers.map((p) => p.id).join(",") } });
    },
  },
};
</script>

<style scoped>
.page-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  padding-bottom: 40px;
}
.header-icon-wrap {
  width: 48px;
  height: 48px;
  background: rgba(255,255,255,0.15);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.table-card {
  border-radius: 12px;
  border: 1px solid #e9ecef;
  overflow: hidden;
}
.table-th {
  font-size: 0.73rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  font-weight: 600;
  border-bottom: 2px solid #e2e8f0;
  padding: 12px 16px;
}
.table-row:hover { background: #f8fafc; }
.btn-submit {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  border: none;
  color: #fff;
  border-radius: 8px;
  font-weight: 600;
  padding: 6px 14px;
}
.btn-submit:hover { opacity: 0.9; color: #fff; }
</style>
